import httpClient from '@/apis/base/httpclient';
import DashboardApi from './_dashboardApi';

class DashboardBudgetPlanImplementationAPI extends DashboardApi {
  constructor() {
    super();
  }
  controllerName = 'Dashboards';

  /**
   * Lấy dữ liệu combo nguồn
   * @param {*} payload 
   * TVANH 26.06.2023
   */
  async getComboboxPaging(payload){
    var payload = {
      ToDate: new Date(),
      Chart: 1
    }
    let request = {
      url: this.getAPIUrl() + '/DataChartArises',
      data: payload
    };
    return httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu biểu đồ
   * @returns
   * TVANH 20.06.2023
   */
  async getChartData(param) {
    let apiUrl = this.getAPIUrl();
    let result = [];

    let request = {
      url: apiUrl + '/DataChart',
      data: param,
    };

    await httpClient.postAsync(request).then(res => {
      result = [0, res.amountUsed, res.amountRest];
    });
    
    return result;
  }
  /**
   * Hàm lấy dữ liệu biểu đồ
   * @returns
   * NBTIN 27.05.2024
   */
  async getChartDataMisaAva(param) {
    let apiUrl = this.getAPIUrl();
    let result = [];

    let request = {
      url: apiUrl + '/DataChartMisaAva',
      data: param,
    };

    return await httpClient.postAsync(request);
  }
}

export default new DashboardBudgetPlanImplementationAPI();
